import { Alert, Snackbar } from '@mui/material';
import React from 'react';
import { connect } from 'react-redux';

import { SnackMessageData } from 'app/model/snack-message-data';
import { RootState } from 'app/store';

import { hideMessage, selectActiveMessage } from './messaging.slice';

interface MessageSnackProps {
    activeMessage?: SnackMessageData;

    hideMessage: () => void;
}

class MessageSnack extends React.Component<MessageSnackProps> {
    public render() {
        const open = undefined !== this.props.activeMessage;

        return (
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                autoHideDuration={6000}
                onClose={() => this.props.hideMessage()}
                action='Close'
            >
                <Alert severity={this.props.activeMessage?.type} onClose={() => this.props.hideMessage()}>
                    {this.props.activeMessage?.message}
                </Alert>
            </Snackbar>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    activeMessage: selectActiveMessage(state),
});

const connected = connect(mapStateToProps, { hideMessage })(MessageSnack);

export { connected as MessageSnack };
